var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg500Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1034,
    height: 1034,
    viewBox: "0 0 1034 1034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 82.878,
    height: 81.373,
    fill: "#b54f34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 1034,
    height: 1034,
    transform: "translate(0.22 0.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_1100101",
    x: 61,
    y: 345,
    width: 220,
    height: 88,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_1100101-2",
    x: 763,
    y: 221,
    width: 220,
    height: 88,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_1100101-3",
    x: 742,
    y: 551,
    width: 220,
    height: 88,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_1100101-4",
    x: 42,
    y: 670,
    width: 220,
    height: 88,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7951",
    "data-name": "Group 7951",
    transform: "translate(-809 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7943",
    "data-name": "Group 7943",
    transform: "translate(1375.111 568.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7918",
    "data-name": "Group 7918",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7916",
    "data-name": "Group 7916",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M82.875,33.872a3.783,3.783,0,0,1-4.111,2.653c-3.26-.1-6.526-.024-9.792-.024h-.958c-.064,1.065-.117,2.082-.189,3.085A27.929,27.929,0,0,1,64.8,50.9a.831.831,0,0,0,.184,1.159L65,52.07C68.341,55.4,71.659,58.76,75,62.1a3.4,3.4,0,0,1,1.164,3.267,3.264,3.264,0,0,1-5.5,1.7c-2.867-2.776-5.676-5.615-8.5-8.435-.59-.59-1.147-1.215-1.735-1.831a26.05,26.05,0,0,1-15.665,6.247V16.677H38.134V62.938c-3.9.309-10.412-1.562-16.251-6.708L16.1,62.77c-1.2,1.353-2.379,2.721-3.6,4.057a3.256,3.256,0,0,1-3.6,1.01A3.114,3.114,0,0,1,6.68,65.114a3.6,3.6,0,0,1,1.086-3.005c3.221-3.6,6.421-7.21,9.638-10.813.295-.332.529-.594.276-1.118a30.58,30.58,0,0,1-2.755-12.534c-.012-.346,0-.694,0-1.138H13.883c-3.588,0-7.175.009-10.759-.027A3.231,3.231,0,0,1,.2,34.3a3.173,3.173,0,0,1,.868-3.481,3.557,3.557,0,0,1,2.669-.944H14.875c.016-.322.039-.584.039-.842,0-4.558.014-9.119-.021-13.676a1.862,1.862,0,0,0-.488-1.178c-2.721-2.776-5.48-5.506-8.22-8.261A3.3,3.3,0,0,1,10.2.68c.083.063.162.13.239.2.225.19.433.4.644.612,2.646,2.644,5.289,5.308,7.966,7.93a1.967,1.967,0,0,0,1.241.539q21.162.042,42.325,0a1.857,1.857,0,0,0,1.178-.5c2.809-2.759,5.567-5.573,8.376-8.33A3.27,3.27,0,0,1,77.74,2.423a3.058,3.058,0,0,1-.521,2.9,9.4,9.4,0,0,1-.765.835c-2.669,2.674-5.345,5.338-8,8.023a1.465,1.465,0,0,0-.466.867c-.025,4.859-.013,9.718,0,14.565a1.21,1.21,0,0,0,.088.256H68.9c3.182,0,6.368.075,9.544-.027a4.094,4.094,0,0,1,4.439,2.571v1.456Z",
    transform: "translate(0 13.353)",
    fill: "#b54f34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M.005,16.67A15.743,15.743,0,0,1,7.592,2.787a15.766,15.766,0,0,1,17.784-.08,15.772,15.772,0,0,1,7.739,13.961Z",
    transform: "translate(24.876 0)",
    fill: "#b54f34"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7950",
    "data-name": "Group 7950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7942",
    "data-name": "Group 7942",
    transform: "translate(808.78 22.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7941",
    "data-name": "Group 7941",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M315.577,125.392H172.641a6.9,6.9,0,1,1,0-13.793H315.577a6.9,6.9,0,1,1,0,13.793",
    transform: "translate(120.01 80.805)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M598.483,292.059H455.547a6.9,6.9,0,0,1,0-13.793H598.483a6.9,6.9,0,0,1,0,13.793",
    transform: "translate(324.853 201.483)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    "data-name": "Path 3118",
    d: "M226.687,346.759H83.751a6.9,6.9,0,0,1,0-13.793H226.687a6.9,6.9,0,0,1,0,13.793",
    transform: "translate(55.648 241.089)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M448.029,145.6H305.093a6.9,6.9,0,1,1,0-13.793H448.029a6.9,6.9,0,1,1,0,13.793",
    transform: "translate(215.914 95.434)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M333.5,468.673H190.564a6.9,6.9,0,1,1,0-13.793H333.5a6.9,6.9,0,0,1,0,13.793",
    transform: "translate(132.988 329.363)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M417.26,493.459H274.324a6.9,6.9,0,1,1,0-13.793H417.26a6.9,6.9,0,1,1,0,13.793",
    transform: "translate(193.635 347.31)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3164",
    "data-name": "Path 3164",
    d: "M556.276,639.667H243.823c-28.516,0-51.717-17.64-51.717-39.32V231.724c0-21.68,23.2-39.32,51.717-39.32H556.276c28.516,0,51.717,17.64,51.717,39.32V600.347c0,21.68-23.2,39.32-51.717,39.32M243.823,205.511c-19.011,0-34.477,11.76-34.477,26.213V600.347c0,14.453,15.467,26.213,34.477,26.213H556.276c19.011,0,34.477-11.76,34.477-26.213V231.724c0-14.453-15.466-26.213-34.477-26.213Z",
    transform: "translate(117.17 101.184)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M388.262,237.024H278.251v24.694H388.262Zm-74.431,16.063h-5.114a3.718,3.718,0,0,1,0-7.436h5.114a3.718,3.718,0,0,1,0,7.436m21.982,0H330.7a3.718,3.718,0,1,1,0-7.436h5.114a3.718,3.718,0,1,1,0,7.436m21.982,0h-5.112a3.718,3.718,0,1,1,0-7.436h5.112a3.718,3.718,0,1,1,0,7.436",
    transform: "translate(201.472 171.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3169",
    "data-name": "Path 3169",
    d: "M438.621,287.682H448.3a4.144,4.144,0,0,0,4.138-4.138V230.557a4.144,4.144,0,0,0-4.138-4.138H223.42a4.144,4.144,0,0,0-4.136,4.138v52.987a4.144,4.144,0,0,0,4.136,4.138h215.2Zm-125.11-46.7a3.719,3.719,0,0,1,3.717-3.719H434.677a3.719,3.719,0,0,1,3.717,3.719v32.13a3.719,3.719,0,0,1-3.717,3.719H317.228a3.719,3.719,0,0,1-3.717-3.719Zm-27.014,0a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Zm0,24.2a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Zm-18-24.2a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Zm0,24.2a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Zm-18-24.2a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Zm0,24.2a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Zm-18-24.2a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Zm0,24.2a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Z",
    transform: "translate(158.776 163.942)",
    fill: "#cdc9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    "data-name": "Path 3170",
    d: "M366.062,314.833a75.583,75.583,0,0,1,22.216-10.006V290.162H278.257v24.671Zm-13.386-16.044h5.114a3.718,3.718,0,0,1,0,7.436h-5.114a3.718,3.718,0,0,1,0-7.436m-21.982,0h5.114a3.718,3.718,0,1,1,0,7.436h-5.114a3.718,3.718,0,1,1,0-7.436m-21.982,0h5.112a3.718,3.718,0,1,1,0,7.436h-5.112a3.718,3.718,0,0,1,0-7.436",
    transform: "translate(201.476 210.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    d: "M278.258,343.3v24.67h59.394a75.366,75.366,0,0,1-5.372-24.67Zm35.567,16.058h-5.112a3.718,3.718,0,1,1,0-7.436h5.112a3.718,3.718,0,1,1,0,7.436",
    transform: "translate(201.477 248.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 198.088,
    height: 15.477,
    transform: "translate(395.592 459.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    d: "M229.45,319.391V334.9H370.706a75.442,75.442,0,0,1,6.717-15.506Z",
    transform: "translate(166.137 231.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    "data-name": "Path 3174",
    d: "M317.243,383.083a3.718,3.718,0,0,1-3.719-3.717V347.26a3.719,3.719,0,0,1,3.719-3.719h57.739a76.039,76.039,0,0,1,1.247-10.844h-152.8a4.15,4.15,0,0,0-4.146,4.145v53a4.127,4.127,0,0,0,4.146,4.095H390.962a75.945,75.945,0,0,1-7.151-10.85Zm-77.307-3.7a3.718,3.718,0,1,1-7.436,0v-7.929a3.718,3.718,0,1,1,7.436,0Zm0-24.19a3.718,3.718,0,1,1-7.436,0v-7.934a3.718,3.718,0,1,1,7.436,0Zm18,24.19a3.718,3.718,0,1,1-7.436,0v-7.929a3.718,3.718,0,1,1,7.436,0Zm0-24.19a3.718,3.718,0,1,1-7.436,0v-7.934a3.718,3.718,0,1,1,7.436,0Zm18,24.19a3.718,3.718,0,1,1-7.436,0v-7.929a3.718,3.718,0,1,1,7.436,0Zm0-24.19a3.718,3.718,0,1,1-7.436,0v-7.934a3.718,3.718,0,1,1,7.436,0Zm18,24.19a3.718,3.718,0,1,1-7.436,0v-7.929a3.718,3.718,0,1,1,7.436,0Zm0-24.19a3.718,3.718,0,1,1-7.436,0v-7.934a3.718,3.718,0,1,1,7.436,0Z",
    transform: "translate(158.773 240.895)",
    fill: "#cdc9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    "data-name": "Path 3176",
    d: "M389.662,340.794a76.431,76.431,0,0,1,9.734-10.848H317.242a3.719,3.719,0,0,1-3.717-3.719V294.122a3.719,3.719,0,0,1,3.717-3.719H434.7a3.719,3.719,0,0,1,3.719,3.719V310.9a75.687,75.687,0,0,1,12.3-1.09c.576,0,1.133.074,1.705.086V283.7a4.126,4.126,0,0,0-4.1-4.145h-224.9a4.15,4.15,0,0,0-4.146,4.145v53a4.126,4.126,0,0,0,4.146,4.095H389.662ZM286.5,294.122a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,0,1-7.436,0Zm0,24.19a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Zm-18-24.19a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,0,1-7.436,0Zm0,24.19a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Zm-18-24.19a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,0,1-7.436,0Zm0,24.19a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Zm-18-24.19a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,0,1-7.436,0Zm0,24.19a3.718,3.718,0,1,1,7.436,0v7.934a3.718,3.718,0,1,1-7.436,0Z",
    transform: "translate(158.774 202.419)",
    fill: "#cdc9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    "data-name": "Path 3177",
    d: "M230.666,301.22a3.719,3.719,0,0,0,3.719-3.719v-7.934a3.719,3.719,0,0,0-7.438,0V297.5a3.719,3.719,0,0,0,3.719,3.719",
    transform: "translate(164.325 206.974)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    d: "M241.106,301.22a3.719,3.719,0,0,0,3.719-3.719v-7.934a3.719,3.719,0,0,0-7.438,0V297.5a3.719,3.719,0,0,0,3.719,3.719",
    transform: "translate(171.884 206.974)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3179",
    "data-name": "Path 3179",
    d: "M251.548,301.22a3.719,3.719,0,0,0,3.719-3.719v-7.934a3.719,3.719,0,0,0-7.438,0V297.5a3.719,3.719,0,0,0,3.719,3.719",
    transform: "translate(179.444 206.974)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3180",
    "data-name": "Path 3180",
    d: "M261.988,301.22A3.718,3.718,0,0,0,265.7,297.5v-7.934a3.718,3.718,0,0,0-7.436,0V297.5a3.719,3.719,0,0,0,3.719,3.719",
    transform: "translate(187.004 206.974)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    "data-name": "Path 3181",
    d: "M230.666,315.251a3.719,3.719,0,0,0,3.719-3.719V303.6a3.719,3.719,0,0,0-7.438,0v7.934a3.719,3.719,0,0,0,3.719,3.719",
    transform: "translate(164.325 217.134)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    "data-name": "Path 3182",
    d: "M241.106,315.251a3.719,3.719,0,0,0,3.719-3.719V303.6a3.719,3.719,0,0,0-7.438,0v7.934a3.719,3.719,0,0,0,3.719,3.719",
    transform: "translate(171.884 217.134)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    "data-name": "Path 3183",
    d: "M251.548,315.251a3.719,3.719,0,0,0,3.719-3.719V303.6a3.719,3.719,0,0,0-7.438,0v7.934a3.719,3.719,0,0,0,3.719,3.719",
    transform: "translate(179.444 217.134)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    "data-name": "Path 3184",
    d: "M261.988,315.251a3.718,3.718,0,0,0,3.717-3.719V303.6a3.718,3.718,0,0,0-7.436,0v7.934a3.719,3.719,0,0,0,3.719,3.719",
    transform: "translate(187.004 217.134)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3185",
    "data-name": "Path 3185",
    d: "M230.666,338.984a3.719,3.719,0,0,0-3.719,3.719v7.934a3.719,3.719,0,0,0,7.438,0V342.7a3.719,3.719,0,0,0-3.719-3.719",
    transform: "translate(164.325 245.447)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    "data-name": "Path 3186",
    d: "M241.106,338.984a3.719,3.719,0,0,0-3.719,3.719v7.934a3.719,3.719,0,0,0,7.438,0V342.7a3.719,3.719,0,0,0-3.719-3.719",
    transform: "translate(171.884 245.447)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    "data-name": "Path 3187",
    d: "M251.548,338.984a3.719,3.719,0,0,0-3.719,3.719v7.934a3.719,3.719,0,0,0,7.438,0V342.7a3.719,3.719,0,0,0-3.719-3.719",
    transform: "translate(179.444 245.447)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    d: "M261.988,338.984a3.719,3.719,0,0,0-3.719,3.719v7.934a3.718,3.718,0,0,0,7.436,0V342.7a3.718,3.718,0,0,0-3.717-3.719",
    transform: "translate(187.004 245.447)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    d: "M230.666,353.019a3.719,3.719,0,0,0-3.719,3.719v7.929a3.719,3.719,0,0,0,7.438,0v-7.929a3.719,3.719,0,0,0-3.719-3.719",
    transform: "translate(164.325 255.609)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    "data-name": "Path 3190",
    d: "M241.106,353.019a3.719,3.719,0,0,0-3.719,3.719v7.929a3.719,3.719,0,0,0,7.438,0v-7.929a3.719,3.719,0,0,0-3.719-3.719",
    transform: "translate(171.884 255.609)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    "data-name": "Path 3191",
    d: "M251.548,353.019a3.719,3.719,0,0,0-3.719,3.719v7.929a3.719,3.719,0,0,0,7.438,0v-7.929a3.719,3.719,0,0,0-3.719-3.719",
    transform: "translate(179.444 255.609)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    "data-name": "Path 3192",
    d: "M261.988,353.019a3.719,3.719,0,0,0-3.719,3.719v7.929a3.718,3.718,0,0,0,7.436,0v-7.929a3.718,3.718,0,0,0-3.717-3.719",
    transform: "translate(187.004 255.609)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3193",
    "data-name": "Path 3193",
    d: "M297.483,302.6h5.112a3.718,3.718,0,1,0,0-7.436h-5.112a3.718,3.718,0,0,0,0,7.436",
    transform: "translate(212.706 213.72)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3194",
    "data-name": "Path 3194",
    d: "M310.233,302.6h5.115a3.718,3.718,0,0,0,0-7.436h-5.115a3.718,3.718,0,0,0,0,7.436",
    transform: "translate(221.938 213.72)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    "data-name": "Path 3195",
    d: "M322.985,302.6H328.1a3.718,3.718,0,1,0,0-7.436h-5.112a3.718,3.718,0,1,0,0,7.436",
    transform: "translate(231.17 213.72)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    "data-name": "Path 3196",
    d: "M230.666,248.082a3.719,3.719,0,0,0,3.719-3.717v-7.936a3.719,3.719,0,0,0-7.438,0v7.936a3.719,3.719,0,0,0,3.719,3.717",
    transform: "translate(164.325 168.499)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    "data-name": "Path 3197",
    d: "M241.106,248.082a3.719,3.719,0,0,0,3.719-3.717v-7.936a3.719,3.719,0,0,0-7.438,0v7.936a3.719,3.719,0,0,0,3.719,3.717",
    transform: "translate(171.884 168.499)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    "data-name": "Path 3198",
    d: "M251.548,248.082a3.719,3.719,0,0,0,3.719-3.717v-7.936a3.719,3.719,0,0,0-7.438,0v7.936a3.719,3.719,0,0,0,3.719,3.717",
    transform: "translate(179.444 168.499)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    "data-name": "Path 3199",
    d: "M261.988,248.082a3.718,3.718,0,0,0,3.717-3.717v-7.936a3.718,3.718,0,0,0-7.436,0v7.936a3.719,3.719,0,0,0,3.719,3.717",
    transform: "translate(187.004 168.499)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    "data-name": "Path 3200",
    d: "M230.666,262.116a3.719,3.719,0,0,0,3.719-3.717v-7.936a3.719,3.719,0,0,0-7.438,0V258.4a3.719,3.719,0,0,0,3.719,3.717",
    transform: "translate(164.325 178.66)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    "data-name": "Path 3201",
    d: "M241.106,262.116a3.719,3.719,0,0,0,3.719-3.717v-7.936a3.719,3.719,0,0,0-7.438,0V258.4a3.719,3.719,0,0,0,3.719,3.717",
    transform: "translate(171.884 178.66)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    "data-name": "Path 3202",
    d: "M251.548,262.116a3.719,3.719,0,0,0,3.719-3.717v-7.936a3.719,3.719,0,0,0-7.438,0V258.4a3.719,3.719,0,0,0,3.719,3.717",
    transform: "translate(179.444 178.66)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    d: "M261.988,262.116A3.718,3.718,0,0,0,265.7,258.4v-7.936a3.718,3.718,0,0,0-7.436,0V258.4a3.719,3.719,0,0,0,3.719,3.717",
    transform: "translate(187.004 178.66)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    "data-name": "Path 3204",
    d: "M277.655,272.278H395.1a3.719,3.719,0,0,0,3.717-3.717V236.429a3.719,3.719,0,0,0-3.717-3.717H277.655a3.718,3.718,0,0,0-3.717,3.717V268.56a3.718,3.718,0,0,0,3.717,3.717m3.719-32.13H391.385v24.694H281.374Z",
    transform: "translate(198.349 168.499)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    "data-name": "Path 3205",
    d: "M302.6,242.028h-5.112a3.718,3.718,0,1,0,0,7.436H302.6a3.718,3.718,0,1,0,0-7.436",
    transform: "translate(212.706 175.244)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    "data-name": "Path 3206",
    d: "M315.348,242.028h-5.115a3.718,3.718,0,0,0,0,7.436h5.115a3.718,3.718,0,1,0,0-7.436",
    transform: "translate(221.938 175.244)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    "data-name": "Path 3207",
    d: "M328.1,242.028h-5.112a3.718,3.718,0,1,0,0,7.436H328.1a3.718,3.718,0,1,0,0-7.436",
    transform: "translate(231.17 175.244)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    d: "M302.6,348.3h-5.112a3.718,3.718,0,1,0,0,7.436H302.6a3.718,3.718,0,1,0,0-7.436",
    transform: "translate(212.706 252.193)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    d: "M462.977,352.018V325.3a11.568,11.568,0,0,0-11.531-11.581h-5.981v-15.48h5.958A11.589,11.589,0,0,0,463,286.667V233.681a11.589,11.589,0,0,0-11.574-11.575H226.545a11.589,11.589,0,0,0-11.574,11.575v52.986a11.589,11.589,0,0,0,11.574,11.575h5.96v15.48H226.55A11.6,11.6,0,0,0,214.968,325.3v53A11.571,11.571,0,0,0,226.55,389.83h5.95v15.506h-5.95a11.6,11.6,0,0,0-11.582,11.581v53a11.572,11.572,0,0,0,11.582,11.531H400.676a75.876,75.876,0,1,0,62.3-129.426M226.545,290.807a4.144,4.144,0,0,1-4.136-4.139V233.681a4.143,4.143,0,0,1,4.136-4.139H451.424a4.145,4.145,0,0,1,4.138,4.139v52.986a4.146,4.146,0,0,1-4.138,4.139H226.545Zm211.484,22.913H239.941V298.242H438.029ZM226.55,382.394A4.126,4.126,0,0,1,222.4,378.3v-53a4.15,4.15,0,0,1,4.146-4.145h224.9a4.125,4.125,0,0,1,4.095,4.145v26.2c-.571-.014-1.128-.088-1.7-.088a75.67,75.67,0,0,0-12.3,1.09V335.722A3.719,3.719,0,0,0,437.822,332H320.365a3.719,3.719,0,0,0-3.717,3.719v32.106a3.719,3.719,0,0,0,3.717,3.719h82.153a76.327,76.327,0,0,0-9.734,10.848H226.55Zm207.555-42.955V354.1a75.573,75.573,0,0,0-22.218,10.006h-87.8V339.439Zm-52.913,65.9H239.936V389.83H387.909a75.44,75.44,0,0,0-6.717,15.506m2.284,50.386H324.084v-24.67h54.022a75.354,75.354,0,0,0,5.37,24.67M226.55,474.008a4.126,4.126,0,0,1-4.146-4.095v-53a4.15,4.15,0,0,1,4.146-4.145h152.8a76.286,76.286,0,0,0-1.247,10.844H320.365a3.719,3.719,0,0,0-3.717,3.719v32.106a3.719,3.719,0,0,0,3.717,3.719h66.568a75.889,75.889,0,0,0,7.153,10.848Zm227.287,21.809a68.485,68.485,0,1,1,68.482-68.487,68.563,68.563,0,0,1-68.482,68.487",
    transform: "translate(155.651 160.819)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    "data-name": "Path 3213",
    d: "M375.4,298.844c8.079,3.21,16.637,7.353,24.625,19.394a3.721,3.721,0,0,0,3.1,1.66,3.681,3.681,0,0,0,2.053-.621,3.721,3.721,0,0,0,1.043-5.155c-9.177-13.827-19.3-18.706-28.076-22.192a3.719,3.719,0,0,0-2.745,6.914",
    transform: "translate(274.285 205.817)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    d: "M367.345,296.8c.1.01,1.412.112,3.512.493a3.86,3.86,0,0,0,.671.059,3.719,3.719,0,0,0,.66-7.377,41.655,41.655,0,0,0-4.352-.591,3.763,3.763,0,0,0-3.941,3.467,3.712,3.712,0,0,0,3.45,3.95",
    transform: "translate(267.65 204.162)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 12.858,
    height: 34.341,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 639.467, 660.785)",
    fill: "#263444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    d: "M452.914,509.964a12.861,12.861,0,0,1-17.565-4.7l-56.667-98.153a12.858,12.858,0,1,1,22.271-12.858L457.621,492.4a12.856,12.856,0,0,1-4.707,17.563",
    transform: "translate(270.232 282.899)",
    fill: "#b54f34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    d: "M426.769,444.854A82.173,82.173,0,1,1,456.847,332.6a82.265,82.265,0,0,1-30.078,112.251M352.307,315.879a66.753,66.753,0,1,0,91.186,24.433,66.828,66.828,0,0,0-91.186-24.433",
    transform: "translate(220.543 216.662)",
    fill: "#263444"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 809, 23)",
    filter: "url(#_1100101)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1100101-5",
    "data-name": 1100101,
    transform: "translate(70 406)",
    fill: "#263444",
    fontSize: 56,
    fontFamily: "SourceSansPro-Semibold, Source Sans Pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1100101"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 809, 23)",
    filter: "url(#_1100101-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1100101-6",
    "data-name": 1100101,
    transform: "translate(772 282)",
    fill: "#263444",
    fontSize: 56,
    fontFamily: "SourceSansPro-Semibold, Source Sans Pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1100101"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 809, 23)",
    filter: "url(#_1100101-3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1100101-7",
    "data-name": 1100101,
    transform: "translate(751 612)",
    fill: "#263444",
    fontSize: 56,
    fontFamily: "SourceSansPro-Semibold, Source Sans Pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1100101"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 809, 23)",
    filter: "url(#_1100101-4)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1100101-8",
    "data-name": 1100101,
    transform: "translate(51 731)",
    fill: "#263444",
    fontSize: 56,
    fontFamily: "SourceSansPro-Semibold, Source Sans Pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1100101")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500Error);
export default __webpack_public_path__ + "static/media/500-error.54f4f11e236277939ad6c21115ec7dc5.svg";
export { ForwardRef as ReactComponent };